// src/pages/HomePage.jsx
import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/services/training/Hero';
import OurTraining from '../components/services/training/OurTraining';
import OurPlatform from '../components/services/training/OurPlatform';
import TrainerCertifications from '../components/services/TrainerCertifications';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const TrainingPage = () => {
    return (
        <>
            <Navbar />
            <Hero />
            <OurTraining />
            <OurPlatform />
            <TrainerCertifications />
            <Contact />
            <Footer />
        </>
    );
};

export default TrainingPage;
